import { render, staticRenderFns } from "./IconSswk.vue?vue&type=template&id=7707b066"
import script from "./IconSswk.vue?vue&type=script&lang=js"
export * from "./IconSswk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports